import Vue from "@src/libraries/vue";
import _window from "@src/libraries/window";
import LocalStorage from "@src/libraries/LocalStorage";
import axios from "@src/libraries/axios";
import { getBugsnag } from '@src/plugins/bugsnag';
import http from "@src/assets/js/requests/http";
import request from "@src/assets/js/requests/request";
import storage, { persistent } from "@src/assets/js/requests/storage";
import { timeout, stringify, API_V2_URL, reload } from "@src/assets/js/utils";
import { error, throwSwal } from "@src/assets/js/exceptions";
import { silentReport } from "@src/assets/js/report";
import store from "@src/store";
let iframe;
if (process.client) {
    iframe = document.createElement('iframe');
    iframe.style.cssText = "display: none";
    iframe.src = "https://s-api.comoquiero.net/s/track";
    document.documentElement.append(iframe);
}
const usersStore = new Vue({
    name: "UsersStore",
    data() {
        const data = {
            loading: "",
        };
        return data;
    },
    computed: {
        admin() {
            const me = this.me;
            return !!me && me.id === 1;
        },
        email() {
            const me = this.me;
            if (!me)
                return "";
            return this.userEmail(me);
        },
        phone() {
            return "";
        },
        username() {
            const me = this.me;
            if (!me)
                return "";
            return me.nickname || me.full_name;
        },
        isStaff() {
            const meId = this.meId;
            if (!meId)
                return false;
            const staff = [
                1,
                52,
                3,
                4,
                5,
                98,
                3146,
                19069,
                19342,
                25324,
                24197,
                26729,
                7556,
                18402
            ];
            return staff.includes(meId);
        },
        paymentsTester() {
            const me = this.me;
            if (!me)
                return false;
            const fidelis = "string" === typeof me.email && me.email.includes("@fidelis.cl");
            if (fidelis)
                return true;
            return [
                52,
                7556,
                18402,
                18863,
                34250,
                42789,
            ].includes(me.id);
        }
    },
    asyncComputed: {
        userTypes: {
            lazy: true,
            async get() {
                return request.pub(API_V2_URL + "/userTypes", "Array");
            }
        },
        async me() {
            if (!process.client)
                return;
            await timeout(1);
            let Authorization = await persistent.getItem("Authorization");
            if (!Authorization) {
                try {
                    Authorization = await getAuthorization();
                }
                catch (e) {
                    console.log("getAuthorization catch", e);
                }
            }
            if (Authorization) {
                try {
                    const me = await http.get(API_V2_URL + "/users/me", "Object", { Authorization });
                    if (me)
                        return me;
                }
                catch (e) {
                    console.log("http.get catch", e);
                }
            }
            const storageMe = await storage.get(API_V2_URL + "/users/me", "Object");
            if (storageMe)
                return storageMe;
            return false;
        },
        meId: {
            async get() {
                if (!process.client)
                    return;
                const me = this.me;
                if (me && me.id)
                    return me.id;
                const persistentID = await persistent.getItem("user_id");
                if (persistentID)
                    return Number(persistentID);
            },
            default: LocalStorage.getItem("user_id")
        }
    },
    watch: {
        admin(admin) {
            if (admin) {
                LocalStorage.setItem("admin", "1");
                document.documentElement.classList.add("admin");
            }
            else {
                LocalStorage.removeItem("admin");
                document.documentElement.classList.remove("admin");
            }
        },
        meId: {
            immediate: true,
            async handler(meId) {
                if (meId) {
                    getBugsnag().then(bugsnag => {
                        bugsnag && bugsnag.setUser(meId);
                    });
                }
            }
        },
        me: {
            immediate: true,
            async handler(me, prevMe) {
                var _a;
                if (me && store.loginDialog.model) {
                    Vue.set(store.loginDialog, "model", false);
                }
                if (me && me.id) {
                    persistent.setItem("user_id", "" + me.id);
                }
                if (me) {
                    getBugsnag().then(bugsnag => {
                        bugsnag && bugsnag.setUser(me.id, me.email, me.full_name || me.nickname);
                    });
                }
                if (me && iframe) {
                    (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify({ user: me }), "*");
                }
            }
        }
    },
    methods: {
        async user(userId) {
            if (!userId || 1 == userId)
                return;
            return request.pub(API_V2_URL + "/users/" + userId + "?with=social", "Object");
        },
        userName(user) {
            if (!user)
                return "";
            if (user.full_name)
                return user.full_name;
            const social = user.social;
            if (social && social.length) {
                return social[0].full_name || "";
            }
            return "";
        },
        userIdName(userId) {
            const getUser = this.user;
            const userName = this.userName;
            return new Promise(function (resolve) {
                getUser(userId).then((user) => {
                    const name = user && userName(user);
                    resolve(name);
                });
            });
        },
        userEmail(user) {
            if (!user)
                return "";
            const userEmail = user.email;
            if (userEmail)
                return userEmail;
            if (user.social && user.social.length) {
                for (const social of user.social) {
                    const socialEmail = social.email;
                    if (socialEmail)
                        return socialEmail;
                }
            }
            return "";
        },
        async reset(Authorization) {
            let userResponse;
            const headers = {
                "cache-control": "max-age=0, no-cache, no-store, private"
            };
            if (Authorization) {
                headers.Authorization = Authorization;
            }
            try {
                userResponse = await axios.get(API_V2_URL + "/users/me", { headers });
            }
            catch (e) {
                silentReport(e);
            }
            if (!userResponse) {
                return;
            }
            if (!userResponse.data) {
                return;
            }
            const me = userResponse.data;
            if (!me.id) {
                silentReport("!me.id", { response: userResponse.data });
                console.log("!me.id", userResponse.data);
                return;
            }
            console.log("me", me);
            if (me && stringify(me) != stringify(this.me)) {
                this.me = me;
            }
            return me;
        },
        async checkLogin() {
            const me = this.me;
            const login = this.login;
            if (me)
                return;
            const logged = await login();
            if (logged)
                return;
            return new Promise(function () { });
        },
        async getMe() {
            const reset = this.reset;
            if (usersStore.me)
                return usersStore.me;
            if (!process.client)
                return false;
            const Authorization = await getAuthorization();
            if (Authorization) {
                const me = await reset();
                if (me && me.id)
                    return me;
            }
        },
        async login() {
            const me = await this.getMe();
            if (me)
                return me;
            console.log("login() loginDialog.model = true");
            Vue.set(store.loginDialog, "model", true);
            return false;
        },
        async loginCordovaGoogle() {
            const self = this;
            const clean = this.clean;
            const logout = this.logout;
            const googleplus = _window.plugins ? _window.plugins.googleplus : null;
            if (!googleplus) {
                error("!googleplus");
                return false;
            }
            await clean();
            googleplus.isAvailable(function (available) {
                if (!available)
                    error("!googleplus.isAvailable");
            });
            let errorCode = "";
            const response = await new Promise((resolve) => {
                console.log("plugins.googleplus.login()");
                self.loading = "googleplus login";
                googleplus.login({}, function (response) {
                    console.log("plugins.googleplus.login() googleplus response", response);
                    resolve(response);
                }, function (e) {
                    console.log("plugins.googleplus.login() googleplus error", e);
                    errorCode = e;
                    resolve("");
                });
            });
            console.log("plugins.googleplus.login() async", response, errorCode);
            if (!response) {
                console.log("plugins.googleplus.login() REJECT", errorCode);
                logout();
                const usrCancelStr = errorCode.includes && errorCode.includes("user canceled the sign-in");
                if (12501 == errorCode || usrCancelStr)
                    return;
                error(errorCode || "googleplus.login !response");
                return;
            }
            const accessToken = response.accessToken;
            if (!accessToken) {
                error(response, { response });
                return false;
            }
            let request = API_V2_URL + "/auth/getTokenLogin"
                + "?driver=google&access_token=" + encodeURIComponent(accessToken);
            let getTokenResponse;
            const headers = { "cache-control": "max-age=0, no-cache, no-store, private" };
            try {
                getTokenResponse = await axios.get(request, { headers });
            }
            catch (e) {
                error(e, { response });
                return false;
            }
            const data = getTokenResponse && getTokenResponse.data;
            if (!data || "string" !== typeof data) {
                usersStore.logout();
                error('!data || "string" !== typeof data', { response });
                return false;
            }
            await getTokenLogin("google", data);
            return true;
        },
        loginCordovaFacebook() {
            const facebookConnectPlugin = _window.facebookConnectPlugin;
            facebookConnectPlugin.login(["public_profile", "email"], async function (userData) {
                console.log("userData", userData);
                const accessToken = userData.authResponse.accessToken;
                if (!accessToken)
                    return error("!accessToken");
                const response = await axios.post(API_V2_URL + "/auth/facebook", { accessToken });
                const data = response.data;
                await getTokenLogin("facebook", data);
            }, function (e) {
                if (4201 == e.errorCode || "User cancelled." == e) {
                    return;
                }
                usersStore.logout();
                error(e.errorMessage, {
                    from: "cordova facebook login",
                    e
                });
            });
            return true;
        },
        loginCordovaApple() {
            const cordova = _window.cordova;
            if (!cordova || !cordova.plugins || !cordova.plugins.SignInWithApple) {
                return false;
            }
            cordova.plugins.SignInWithApple.signin({ requestedScopes: [0, 1] }, async function (response) {
                const appleResponse = await axios.post(API_V2_URL + "/auth/apple", {
                    sub: response.user,
                    email: response.email,
                    given_name: response.fullName.givenName,
                    family_name: response.fullName.familyName,
                    name: response.fullName.nickname,
                });
                const data = appleResponse.data;
                await getTokenLogin("apple", data);
            }, function (e) {
                console.log("cordova.plugins.SignInWithApple.signin() REJECT", e);
                if (e.includes && e.includes("user canceled the sign-in")) {
                    return;
                }
                usersStore.logout();
                error(e);
            });
            return true;
        },
        async clean() {
            const promises = [];
            promises.push(persistent.removeItem("login_driver"));
            promises.push(persistent.removeItem("Authorization"));
            promises.push(storage.remove(API_V2_URL + "/users/me"));
            await Promise.all(promises);
            delete axios.defaults.headers.Authorization;
            this.me = false;
            this.meId = undefined;
        },
        async logout() {
            const clean = this.clean;
            console.log("logout");
            Vue.set(store.drawerDialog, "model", false);
            await clean();
            const googleplus = _window.plugins ? _window.plugins.googleplus : null;
            if (googleplus && googleplus.logout)
                await googleplus.logout();
        }
    }
});
export default usersStore;
import("@src/assets/js/debug").then(function (imported) {
    imported.moduleDebug(usersStore);
});
async function getTokenLogin(driver, accessToken) {
    if (!driver) {
        usersStore.logout();
        return throwSwal("!driver");
    }
    await persistent.setItem("login_driver", driver);
    await getAuthorization(driver, accessToken);
}
async function getAuthorization(driver, accessToken) {
    driver = driver || await persistent.getItem("login_driver");
    if (!driver || !accessToken)
        return "";
    const Authorization = "Bearer " + accessToken;
    usersStore.loading = "login response";
    await loginResponse(Authorization, driver);
    usersStore.loading = "";
    return Authorization;
}
async function loginResponse(Authorization, driver) {
    if (!Authorization) {
        await error("missing Authorization", { driver, Authorization });
        return;
    }
    axios.defaults.headers.Authorization = Authorization;
    axios.defaults.headers.common.Authorization = Authorization;
    await persistent.setItem("Authorization", Authorization);
    const logged = await usersStore.reset(Authorization);
    if (!logged) {
        console.warn("loginResponse reload");
        const reloading = await reload();
        if (reloading)
            return;
        await silentReport("not logged", { driver, Authorization });
        await usersStore.logout();
        console.warn("loginResponse reload(true)");
        return;
    }
    Vue.set(store.loginDialog, "model", false);
    Vue.set(store.loginDialog, "social", driver);
}
